import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  startListenMediaDevicesChange,
  mediaDevicesConstraintsChange,
  QUERY_MEDIA_DEVICES_TIMEOUT,
} from './../actions/media'

class AudioDevicesComponent extends Component {

  constructor (props) { // eslint-disable-line no-useless-constructor
    super(props)
  }

  componentDidMount () {
    this.props.startListenMediaDevicesChangeAction()
  }

  componentWillUnmount () {
    // console.log('unmount')
  }

  buildAudioTracksUI ({ stream, constraints, settings }) {
    const tracks = stream.getAudioTracks()
    const constraintsValues = {
      echoCancellation: [false, true],
      autoGainControl: [false, true],
      noiseSuppression: [false, true],
      latency: [0, 0.01, 0.02, 0.05, 0.1, 0.2], // seconds
      sampleRate: [8000, 11025, 22050, 44100, 48000], // samples per second
      sampleSize: [8, 16], // bits per sample
      channelCount: [1, 2],
    }
    const parseVal = (val, key) => {
      if (['echoCancellation', 'autoGainControl', 'noiseSuppression'].indexOf(key) > -1) {
        return (val === 'true')
      }
      if (key === 'latency') {
        return Number.parseFloat(val)
      }
      return Number.parseInt(val, 10)
    }
    const cts = Object.entries(constraintsValues)
      .map(([key, values]) => <p key={key} style={{ textAlign: 'right', padding: '0 50px 0 0', margin: '0' }}>{`${key} `}
        <select
          id={`ct-${key}`}
          value={constraints[key]}
          style={{ width: '100px' }}
          onChange={(event) => {
            this.props.mediaDevicesConstraintsChangeAction({ ...constraints, [key]: parseVal(event.target.value, key) })
          }}>
          {values.map((val) => <option
            key={`${key}-${val}`}
            style={{ padding: '0 10px' }}
            value={val}>
            {typeof val === 'boolean' ? Boolean(val).toString() : val}
          </option>)}
        </select>
        <span style={{ color: 'blue', width: '60px', display: 'inline-block', paddingLeft: '10px' }}>
          {(settings && settings[key] !== undefined) ? (settings[key]).toString() : ' - '}
        </span>
      </p>)
    return <div>
      {cts}
      <p>audio input tracks:
        <select style={{ marginLeft: '10px', paddingLeft: '10px', paddingRight: '10px' }}>
          {tracks.map((track) => <option key={track.id} style={{ padding: '10px' }} value={track.id}>{track.label}</option>)}
        </select>
      </p>
    </div>
  }

  render () {
    const { audioInput, updated, queryDuration, constraints } = this.props.media
    if (updated === 0 && queryDuration === 0) {
      return null
    }
    let message = null
    if (updated === 0 && queryDuration >= QUERY_MEDIA_DEVICES_TIMEOUT) {
      message = <p>{this.context.t('chat-request-browser-microphone-access')}</p>
    }
    if (updated > 0) {
      if (audioInput.notAllowed) {
        message = <p>{this.context.t('chat-request-microphone-not-allowed')}</p>
      } else if (!audioInput.stream) {
        message = <p>{this.context.t('chat-request-microphone-missing')}</p>
      }
    }
    if (!message && this.props.showMediaDevices) {
      message = this.buildAudioTracksUI({
        stream: audioInput.stream,
        constraints,
        settings: audioInput.settings
      })
    }
    return message
  }
}

AudioDevicesComponent.contextTypes = {
  t: PropTypes.func.isRequired
}

AudioDevicesComponent.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object.isRequired,
  startListenMediaDevicesChangeAction: PropTypes.func.isRequired,
  mediaDevicesConstraintsChangeAction: PropTypes.func.isRequired,
  showMediaDevices: PropTypes.bool,
}

function mapStateToProps (state) {
  return {
    media: state.mediaDevices,
  }
}

function mapDispatchToProps (dispatch) {
  return {
    startListenMediaDevicesChangeAction: () => {
      dispatch(startListenMediaDevicesChange())
    },
    mediaDevicesConstraintsChangeAction: (constraints) => {
      dispatch(mediaDevicesConstraintsChange(constraints))
    },
  }
}

export const AudioDevices = connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioDevicesComponent)
